import React from 'react'
import {FormattedDate} from 'react-intl'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {dateStringToMiddayDate} from '@vio/core/src/utils/date'

import {GuestAndRoomText} from '../GuestAndRoomsText'

export interface Props {
  checkIn?: string
  checkOut?: string
  rooms?: string
  hasCustomStyle?: boolean
  hideRoomsCount?: boolean
}

export const DateAndRoomsText = ({
  checkIn,
  checkOut,
  rooms,
  hasCustomStyle,
  hideRoomsCount
}: Props) => {
  return (
    <Box display="flex">
      <Box
        display="flex"
        alignItems="center"
        gap={hasCustomStyle ? 's250' : 's000'}
      >
        {hasCustomStyle && (
          <Icon
            name="Calendar"
            size="sm"
            colorPath="content.neutral.secondary"
          />
        )}
        <Text
          variant="bodyS"
          colorPath={
            hasCustomStyle
              ? 'content.neutral.primary'
              : 'content.neutral.secondary'
          }
          dataId="dates"
        >
          {checkIn && checkOut && (
            <>
              <FormattedDate
                value={dateStringToMiddayDate(checkIn)}
                month="short"
                day="2-digit"
              />
              {' - '}
              <FormattedDate
                value={dateStringToMiddayDate(checkOut)}
                month="short"
                day="2-digit"
              />
            </>
          )}
        </Text>
      </Box>
      {checkIn && checkOut && rooms && (
        <Box paddingRight="s250" paddingLeft="s250">
          <Text variant="bodyS" colorPath="content.neutral.secondary">
            <>{' · '}</>
          </Text>
        </Box>
      )}

      {rooms && (
        <Box
          display="flex"
          alignItems="center"
          gap={hasCustomStyle ? 's250' : 's000'}
        >
          {hasCustomStyle && (
            <Icon name="User" colorPath="content.neutral.secondary" size="sm" />
          )}
          <Text
            tag="span"
            variant="bodyS"
            colorPath={
              hasCustomStyle
                ? 'content.neutral.primary'
                : 'content.neutral.secondary'
            }
            dataId="guestsAndRoomsNumber"
          >
            <GuestAndRoomText rooms={rooms} hideRoomsCount={hideRoomsCount} />
          </Text>
        </Box>
      )}
    </Box>
  )
}
